import {
  Avatar,
  Button,
  Card,
  CardContent,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  useTheme,
} from '@mui/material';
import { Box } from '@mui/system';
import React, { useEffect, useState } from 'react';
// Remove the duplicate import statement
import MotionWrap from 'wrapper/MotionWrap';
import { fleetOverviewSelector } from 'redux/fleets/ducks';
import VehicleUploadSelection from './VehicleUploadSelection';
import {
  getVehicle,
  getVehiclesForFleet,
  uploadServiceReport,
} from 'services/fleet_service';
import { useDispatch } from 'react-redux';
import { setNotification } from 'redux/notifications/ducks';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import ComplianceSelection from './ComplianceSelection';
import UploadTires from '../TireInventory/AddBulkTires/UploadTires';
import { ArrowBackIos, CloudUpload } from '@mui/icons-material';
import { UploadLogo } from 'components/Dropzone/Helper/Helper';
import { makeStyles } from 'tss-react/mui';
import LoadAnimation from 'components/LoadAnimation';
import ServiceDocUploadSelection from './ServiceDocUploadSelection';
import { ReactComponent as Truck } from 'assets/svg/home/truck_uploads.svg';
import { ReactComponent as Tire } from 'assets/svg/home/tire_uploads.svg';

const useStyles = makeStyles()(theme => {
  return {
    serviceProvider: {
      cursor: 'pointer',
      '&:hover': {
        boxShadow: '0px 0px 10px rgba(29, 78, 216, 0.5)',
      },
    },
  };
});
const items = [
  {
    id: 1,
    icon: <Truck stroke={'green'} />,
    identifier: 'vehicles',
  },
  {
    id: 2,
    icon: <Tire fill='green' />,
    identifier: 'tires',
  },
  {
    id: 3,
    icon: '✅',
    identifier: 'compliance',
  },
  {
    id: 4,
    icon: '🏢',
    identifier: 'logo',
  },
  {
    id: 5,
    icon: '📄',
    identifier: 'serviceDoc',
  },
];

const Uploads = () => {
  const { classes } = useStyles();
  const [activeStep, setActiveStep] = useState(0);
  const [skipped, setSkipped] = useState(new Set());
  const theme = useTheme();
  const fleets = useSelector(fleetOverviewSelector)?.fleets;
  const overviewData = useSelector(fleetOverviewSelector);
  const [provisionedVehicleTypes, setProvisionedVehicleTypes] = useState([]);
  const [vehicleType, setVehicleType] = useState(null);
  const [fileData, setFileData] = useState(null);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [isUploading, setIsUploading] = useState(false);
  const [response, setResponse] = useState(null);
  const [selectedFleet, setSelectedFleet] = useState(null);
  const [selected, setSelected] = useState(null);
  const [imgSrc, setImgSrc] = useState(null);
  const [uploadType, setUploadType] = useState(null);
  const [files, setFiles] = useState(null);
  const [step, setStep] = useState(0);
  const [popUpCode, setPopUpCode] = useState(null);
  const [allFleetVehicles, setAllFleetVehicles] = useState([]);
  const [selectedVehicle, setSelectedVehicle] = useState({});
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [content, setContent] = useState(null);
  const handleBack = () => {
    setActiveStep(prevActiveStep => prevActiveStep - 1);
  };

  const handleSelect = id => {
    setSelected(prev => (prev === id ? null : id)); // Deselect if already selected
    let newSkipped = skipped;
    setActiveStep(prevActiveStep => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  useEffect(() => {
    if (overviewData !== null) {
      let temp = overviewData.general_configs;
      let operate_arr = [];
      for (let i = 0; i < Object.values(temp).length; i++) {
        if (Object.values(temp)[i] !== null) {
          operate_arr.push(Object.keys(temp)[i]);
        }
      }

      setProvisionedVehicleTypes(operate_arr);
    }
  }, [overviewData]);

  useEffect(() => {
    if (activeStep === 0) {
      setSelected(null);
      setVehicleType(null);
      setSelectedFleet(null);
      setSelectedVehicle({});
      setActiveStep(0);
      setContent(null);
      setPopUpCode(null);
      setUploadType(null);
      setAllFleetVehicles([]);
    }
  }, [activeStep]);

  const handleUploadComplianceDoc = async () => {
    try {
      setIsUploading(true);
      const formData = new FormData();
      formData.append('document', fileData);
      const response = await uploadServiceReport('compliance', formData);
      if (response.status === 200) {
        dispatch(
          setNotification(
            t('settingsPage.complianceSettings.uploadSuccess'),
            'success',
            true
          )
        );
        setResponse(200);
      } else {
        dispatch(
          setNotification(
            t('settingsPage.complianceSettings.notUpload'),
            'error',
            true
          )
        );
        setResponse(null);
      }
    } catch (error) {
      dispatch(
        setNotification(
          t('settingsPage.complianceSettings.notUpload'),
          'error',
          true
        )
      );
    } finally {
      setIsUploading(false);
    }
  };

  const uploadLogo = async files => {
    try {
      setImgSrc(URL.createObjectURL(files[0]));
      var formData = new FormData();
      formData.append('tag', 'Logo');
      formData.append(files[0]['name'], files[0]);
      await UploadLogo(formData);
    } catch (err) {
      console.error(err);
    }
  };

  const getVehiclesForFleetHandler = async fleet_id => {
    setIsLoadingData(true);
    try {
      const res = await getVehiclesForFleet({ fleet_id }, null, true);

      if (res.status === 200) {
        const vehicles = res?.data?.resp?.vehicles;
        setAllFleetVehicles(vehicles);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoadingData(false);
    }
  };

  const getSpecificVehicleHandler = async vehicle => {
    setIsLoadingData(true);
    try {
      const res = await getVehicle(vehicle, null, true);

      if (res.status === 200) {
        const vehicle = res?.data?.resource;
        setSelectedVehicle(vehicle);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoadingData(false);
    }
  };

  const upload = async () => {
    setIsLoadingData(true);
    let formData = new FormData();
    const item = files[0];
    formData.append('document', item);

    try {
      if (uploadType) {
        const res = await uploadServiceReport(uploadType, formData);
        if (res.status === 200) {
          dispatch(setNotification(t('common.success'), 'success', true));
          setIsLoadingData(true);
          setStep(0);
        } else {
          dispatch(setNotification(res?.data.return_message, 'error', true));
          const resource = res?.data;
          if (res?.data.popUpCode) {
            if (res.data.popUpCode === 'one') {
              dispatch(
                setNotification(res?.data.return_message, 'error', true)
              );
              return;
            }
            setPopUpCode(res?.data.popUpCode);

            setContent(resource);
          }
        }
      } else {
        dispatch(
          setNotification(
            'Some error occurred, please reload page',
            'error',
            true
          )
        );
      }
    } catch (error) {
      console.error('E20101', error);
    } finally {
      setIsLoadingData(false);
    }
  };
  const serviceProviderHandler = event => {
    const choice = event.target.alt;
    setUploadType(choice);
    setStep(0);
  };

  return (
    <>
      <LoadAnimation loading={isLoadingData} />
      <Box
        display={'flex'}
        flexDirection={'column'}
        height={'78vh'}
        data-hook='uploads-component'
      >
        <Box
          display={'flex'}
          flexDirection={'column'}
          justifyContent={'center'}
          alignItems={'center'}
          flex={1}
        >
          {activeStep === 0 && (
            <>
              <Typography variant='subtitle1' sx={{ mt: 2, mb: 1 }}>
                {t('uploadCenter.fileType')}
              </Typography>
              <Grid container spacing={2} sx={{ p: 4 }}>
                {items.map(item => (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    lg={3}
                    key={item.id}
                    data-hook={`item-${item.id}`}
                  >
                    <Card
                      sx={{
                        border:
                          selected === item.id
                            ? `2px solid ${theme.palette.primary.main}`
                            : '1px solid #E5E7EB',
                        boxShadow:
                          selected === item.id
                            ? '0px 0px 10px rgba(29, 78, 216, 0.5)'
                            : '',
                        borderRadius: '8px',
                        transition: 'all 0.3s',
                        cursor: 'pointer',
                        height: '100%',
                      }}
                      onClick={() => handleSelect(item.id)}
                    >
                      <CardContent>
                        <Box
                          display='flex'
                          alignItems='center'
                          justifyContent='space-between'
                        >
                          <Avatar
                            sx={{
                              bgcolor: '#E0F2FE',
                              color: '#0284C7',
                              width: 56,
                              height: 56,
                            }}
                            data-hook={`icon-${item.id}`}
                          >
                            {item.icon}
                          </Avatar>
                        </Box>
                        <Typography
                          variant='h6'
                          sx={{ mt: 2, fontWeight: 'bold' }}
                        >
                          {t(`uploadCenter.${item.identifier}.title`)}
                          {/* {item.identifier} */}
                        </Typography>
                        <Typography
                          variant='body2'
                          sx={{ color: '#6B7280', mt: 1, lineHeight: 1.5 }}
                        >
                          {t(`uploadCenter.${item.identifier}.description`)}
                        </Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </>
          )}
          {activeStep === 1 && (
            <Box>
              {selected === 1 && (
                <VehicleUploadSelection
                  vehicleType={vehicleType}
                  provisionedVehicleTypes={provisionedVehicleTypes}
                  setVehicleType={setVehicleType}
                />
              )}
              {selected === 2 && (
                <Box
                  display={'flex'}
                  flexDirection={'column'}
                  gap={5}
                  minWidth={180}
                >
                  <FormControl variant='outlined' fullWidth>
                    <InputLabel id='demo-simple-select-outlined-label'>
                      {t('singleVehicleUpload.selectFleet')}
                    </InputLabel>
                    <Select
                      required
                      name='fleet'
                      labelId='demo-simple-select-outlined-label'
                      id='demo-simple-select-outlined'
                      value={selectedFleet}
                      onChange={e => {
                        setSelectedFleet(e.target.value);
                      }}
                      label='Select Fleet'
                      variant='outlined'
                      fullWidth
                      data-hook='select-fleet'
                    >
                      {fleets.map(entry => {
                        return (
                          <MenuItem
                            key={entry?.fleet_id}
                            value={entry?.fleet_id}
                          >
                            {entry?.fleet_name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                  {selectedFleet && <UploadTires fleetId={selectedFleet} />}
                </Box>
              )}
              {selected === 3 && (
                <ComplianceSelection
                  fileData={fileData}
                  handleUploadComplianceDoc={handleUploadComplianceDoc}
                  setFileData={setFileData}
                  isUploading={isUploading}
                  response={response}
                />
              )}
              {selected === 4 && (
                <>
                  {imgSrc && (
                    <Box
                      style={{
                        width: 200,
                        height: 100,
                        objectFit: 'contain',
                      }}
                    >
                      <img
                        src={imgSrc}
                        style={{
                          width: 200,
                          height: 100,
                          objectFit: 'contain',
                        }}
                        alt='logo'
                      />
                    </Box>
                  )}
                  <Button
                    component='label'
                    role={undefined}
                    variant='contained'
                    tabIndex={-1}
                    onChange={e => uploadLogo(e.target.files)}
                    startIcon={<CloudUpload />}
                    data-hook='upload-btn'
                  >
                    {imgSrc ? 'Change' : 'Upload'} Logo
                    <input type='file' hidden accept='image/*' />
                  </Button>
                </>
              )}
              {selected === 5 && (
                <ServiceDocUploadSelection
                  classes={classes}
                  selectedFleet={selectedFleet}
                  setSelectedFleet={setSelectedFleet}
                  uploadType={uploadType}
                  files={files}
                  setFiles={setFiles}
                  step={step}
                  setStep={setStep}
                  popUpCode={popUpCode}
                  setPopUpCode={setPopUpCode}
                  allFleetVehicles={allFleetVehicles}
                  selectedVehicle={selectedVehicle}
                  setSelectedVehicle={setSelectedVehicle}
                  isLoadingData={isLoadingData}
                  setIsLoadingData={setIsLoadingData}
                  content={content}
                  setContent={setContent}
                  getVehiclesForFleetHandler={getVehiclesForFleetHandler}
                  getSpecificVehicleHandler={getSpecificVehicleHandler}
                  upload={upload}
                  serviceProviderHandler={serviceProviderHandler}
                />
              )}
            </Box>
          )}
        </Box>
        <Box mt={2} width={'100%'}>
          <Button
            color='primary'
            disabled={activeStep === 0}
            onClick={handleBack}
            sx={{ textTransform: 'unset', margin: 2 }}
            size='small'
            startIcon={<ArrowBackIos />}
            data-hook='back-btn'
          >
            {t('common.back')}
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default MotionWrap(
  Uploads,
  { opacity: 0, scaleY: 0 },
  { opacity: 1, scaleY: 1 },
  { opacity: 0, scaleY: 0 }
);
